var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testimonial"},[_c('blockquote',[_c('QuoteIcon',{staticClass:"icon open"}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.testimonial.content)}}),_c('footer',[_vm._v("\n        - "),_c('cite',{staticClass:"author"},[_vm._v(_vm._s(_vm.testimonial.author))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }